/**
 * Branch Location Configuration
 * This file contains the restaurant branch location information
 * Used for distance calculation and map display
 */

export interface BranchLocation {
  name: string;
  address: string;
  city: string;
  postcode: string;
  latitude: number;
  longitude: number;
}

// Branch location: Saheeh Hürth — exact GPS confirmed by client 2026-04-27
// 50°52'59.7"N 6°52'07.7"E (Sudetenstraße / Cäsarstraße area, 50354 Hürth)
export const BRANCH_LOCATION: BranchLocation = {
  name: 'Saheeh Hürth',
  address: 'Sudetenstraße 60',
  city: 'Hürth',
  postcode: '50354',
  latitude: 50.883251,
  longitude: 6.868818,
};

/**
 * Calculate distance between two coordinates using Haversine formula
 * Returns distance in kilometers
 */
export const calculateDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return Math.round(distance * 10) / 10; // Round to 1 decimal place
};

